export enum TripSortableColumn {
  STARTED_AT = 'started_at',
  COMPLETED_AT = 'completed_at',
  STATUS = 'status'
}
